import { DestroyRef, Directive, ElementRef, inject, Input, input, OnInit, Renderer2 } from '@angular/core';
import { fromEvent, map, Observable, take, takeUntil, tap } from 'rxjs';
import type { Permission } from '../models/auth.model';
import { Store } from '@ngxs/store';
import { UserContextSelectors } from '@app/shared/state/user-context/user-context.selectors';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

@Directive({
  selector: '[permission]',
})
export class PermissionDirective implements OnInit {

  #destroyRef = inject(DestroyRef)
  #elementRef = inject(ElementRef)
  #renderer = inject(Renderer2)
  #store = inject(Store)

  permission = input<Permission>()

  ngOnInit(): void {
    const nativeElement = this.#elementRef.nativeElement;

    fromEvent(nativeElement, 'click').subscribe(() => {
      this.checkPermission()
    });

    // Initial check
    this.checkPermission()
  }

  private checkPermission() {
    this.#store.select(UserContextSelectors.permissionsAreaMap).pipe(
      tap((acl: Record<string, any> | null) => {
        // There is a collission with to models named Permission - thats why im using any.
        // One of the permissions models should be removed.
        const accessKey = `${this.permission().area}::${this.permission().action}`
        const accessLevel = acl?.[accessKey]?.accesslevel ?? 0

        if (accessLevel == 0) this.removeElement()
      }),
      map(() => void 0)
    ).pipe(
      takeUntilDestroyed(this.#destroyRef)
    ).subscribe()
  }

  private removeElement(): void {
    let nativeElement = this.#elementRef.nativeElement;
    this.#renderer.removeChild(nativeElement.parentElement, nativeElement);
  }
}
